import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './Components/Navbar/Navbar'
import Landing from './Components/Landing/Landing'
import Showcase from './Components/Showcase/Showcase'
import Roadmap from './Components/Roadmap/Roadmap'
import Team from './Components/Team/Team'
import About from './Components/About/About'
import Faq from './Components/Faq/Faq'
import Footer from './Components/Footer/Footer'
import Soon from './Components/Soon/Soon'

function App() {
  return (
    <div className='soonBackground'>
      {/* <Soon/> */}
      <Navbar />
      <Landing />
      <Showcase />
      <Roadmap />
      <Team />
      <About />
      <Faq />
      <Footer />
    </div>
  );
}

export default App;
